<template>
  <div class="relative flex flex-col h-screen">
    <Header />
    <router-view class="flex-1 "></router-view>
  </div>
</template>

<script>
import Header from "./components/header";
export default {
  name: "Layout",
  components: { Header },
};
</script>
